import { FC } from "react";
import { Modal } from "../../layout/Modal";
import { ModalItemWithHeader } from "../../layout/ModalItemWithHeader";
import { Button } from "../Button";

export type PeriodDeleteModalProps = {
	deleteFn: () => void;
	onClose: () => void;
};

export const PeriodDeleteModal: FC<PeriodDeleteModalProps> = ({ deleteFn, onClose }) => {
	const handleSubmit = () => {
		deleteFn();
		onClose();
	};

	return (
		<Modal onClickOutside={onClose}>
			<ModalItemWithHeader header="Delete Period" onClose={onClose}>
				<div className="flex flex-col max-w-[600px] pt-4 pb-8 px-8 max-h-[550px]">
					<div className="flex flex-col gap-4 py-2">
						<div className="flex flex-col shrink-0 h-fit text-sm text-secondary items-start justify-start gap-2">
							<div>Are you sure you want to delete this period?</div>
						</div>
					</div>
					<div className="flex flex-row-reverse items-center justify-start gap-2 mt-6">
						<Button
							testId="submit-button"
							className="order-1"
							color="danger"
							onClick={handleSubmit}
							filled
						>
							Delete Period
						</Button>
						<Button testId="cancel-button" className="order-2" color="secondary" onClick={onClose}>
							Cancel
						</Button>
					</div>
				</div>
			</ModalItemWithHeader>
		</Modal>
	);
};
